module.exports = __webpack_public_path__ + "tables/media/ui-elements-dark.2f6cc17b.svg";